module.exports = __webpack_public_path__ + "static/media/ic_dlc_logo.e53b91b0.svg";